import { defaultFilterElement } from './constants';

export const createConditionGroupElement = (id) => {
  return { id, isExpanded: true, thenValue: '', group: [defaultFilterElement] };
};
